// extracted by mini-css-extract-plugin
export default {"input":"FormInputs_input__1zUAH","message":"FormInputs_message__lwiCL","invalid-input":"FormInputs_invalid-input__sflca"};